import { render, staticRenderFns } from "./AccountDropdown.vue?vue&type=template&id=37516cc0&scoped=true&"
import script from "./AccountDropdown.vue?vue&type=script&lang=js&"
export * from "./AccountDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AccountDropdown.vue?vue&type=style&index=0&id=37516cc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37516cc0",
  null
  
)

export default component.exports